import {InjectionToken} from '@angular/core'

export const HOME_PATH = 'home'
export const LIST_PATH = 'list'
export const SETTINGS_PATH = 'settings'
export const LOGIN_PATH = 'login'
export const WINDOW = new InjectionToken<Window>('window')


export const ADMIN_ROLE = 'paymentsUser'


/* Temp copied for now */
export const FILE_READER = new InjectionToken<FileReader>('xFileReader')

/**
 *
 */
export const provideNoopFileReader = () => ({
  provide: FILE_READER,
  useValue: {
    readAsArrayBuffer: () => null,
    result: new ArrayBuffer(200)
  }
})